import { action } from "typesafe-actions";

import { CLEAR_SESSION, ClearSessionAction, SET_IS_AUTH_LOADING, SET_SESSION } from "./types";

// action creators
export const clearSession = (): ClearSessionAction => action(CLEAR_SESSION);
export const setSession = (session: any) => action(SET_SESSION, session);
export const setIsAuthLoading = (isLoading: boolean) => action(SET_IS_AUTH_LOADING, isLoading);
